import { useState, useEffect, useCallback } from 'react';
import { tourApi } from '../services/api';

/**
 * Tracks whether the current user has active tour data.
 * Re-checks after seed/exit/reset operations.
 */
export function useTourStatus() {
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await tourApi.getStatus();
      setActive(data.active);
    } catch {
      setActive(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const seed = useCallback(async () => {
    await tourApi.seed();
    setActive(true);
  }, []);

  const exit = useCallback(async () => {
    await tourApi.exit();
    setActive(false);
  }, []);

  const reset = useCallback(async () => {
    await tourApi.reset();
    setActive(true);
  }, []);

  return { active, loading, seed, exit, reset, refresh };
}
